import { Button, Card, Descriptions, Space, Table } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { InvAdjustmentOrderAPI } from "@/apis/material";
import { Currency } from "@/components/Numeric";
import GLImpactButton from "@/components/GLImpactButton";
import Decimal from "decimal.js";
import _ from "lodash";

export const InvAdjustmentInfo = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [info, setInfo] = useState({});

    const getInfo = useCallback(async () => {
        const values = await InvAdjustmentOrderAPI.get(params.id);
        setInfo(values);
    }, [params]);

    useEffect(() => {
        getInfo();
    }, [getInfo]);

    const totalValueAdjustment = _.reduce(info.items, (sum, item) => new Decimal(sum).plus(item.valueAdjustment ?? 0).toNumber(), 0);

    const columns = [
        { title: (<div style={{ lineHeight: 1.5 }}><div style={{ fontSize: 14, fontWeight: 600 }}>Item Name</div><div style={{ fontSize: 12, color: '#86909c' }}>Description</div></div>), width: 280, render: (col, record) => (<div style={{ lineHeight: 1.5 }}><div style={{ fontSize: 14, fontWeight: 600, color: '#1d2129' }}>{record.itemName || ""}</div><div style={{ fontSize: 12, color: '#86909c' }}>{record.itemDescription || ""}</div></div>) },
        { title: "Location", dataIndex: "locationName" },
        { title: "Lot#", dataIndex: "lot" },
        { title: "Qty", dataIndex: "qty", align: "right" },
        { title: "Cost", dataIndex: "cost", align: "right", render: (col, record) => record.cost != null ? <Currency value={record.cost} /> : "" },
        { title: "Qty Adjustment", dataIndex: "qtyAdjustment", align: "right" },
        { title: "New Qty", dataIndex: "newQty", align: "right" },
        { title: "Value Adjustment", dataIndex: "valueAdjustment", align: "right", render: (col, record) => record.valueAdjustment != null ? <Currency value={record.valueAdjustment} /> : "" },
    ];

    return (
        <Card title={<Space>
            <span>{info.adjustmentNo}</span>
        </Space>} extra={
            <Space>
                <GLImpactButton type="7" from={parseInt(params.id)} />
                <Button onClick={() => navigate("/workspace/material/inventory_adjustment")}>Back</Button>
            </Space>
        }>
            <Descriptions colon=":" data={[
                { label: "Adj. Account", value: info.accountName },
                { label: "User Name", value: info.userName },
                { label: "Warehouse", value: info.warehouseName },
                { label: "Notes", value: info.notes },
            ]} />

            <Table rowKey="id" style={{ marginTop: 16 }}
                columns={columns}
                data={info.items || []}
                pagination={false}
                footer={() => (
                    <div style={{ textAlign: "right" }}>
                        <span>Total Value Adjustment: <Currency value={totalValueAdjustment} /></span>
                    </div>
                )}
            />
        </Card>
    );
};
